import React from 'react';
import UnifiedActivityFeed from './UnifiedActivityFeed';

const ActivityFeedDashboard = ({ 
  compact = true, 
  maxItems = 3, 
  showFilters = false, 
  showHeader = true,
  selectedOwner = null,
  selectedProperty = null 
}) => {
  return (
    <UnifiedActivityFeed 
      mode="dashboard"
      showFilter={showFilters}
      maxItems={maxItems}
      autoRefresh={true}
      refreshInterval={30}
    />
  );
};

export default ActivityFeedDashboard;

